import React from "react";
import { Skeleton, useTheme } from "@mui/material";
import { TableConfig } from "./types";
import { TableBodyCell } from "./TableBodyCell";
import { TableRow } from "./TableRow";

type Props = {
  settings: TableConfig<any>;
};

export const LoadingTableRow = ({ settings }: Props) => {
  const theme = useTheme();

  return (
    <TableRow>
      {settings.columns
        .filter((col) => !col.hidden)
        .map((column) => {
          return (
            <TableBodyCell
              key={`${column.id}-loading`}
              sx={{
                borderBottom: `1px solid transparent`,
              }}
            >
              <Skeleton
                height={settings.loadingRowsHeight ?? "22px"}
                sx={{
                  transform: "none",
                  borderRadius: `${theme.shape.borderRadius}px`,
                }}
              />
            </TableBodyCell>
          );
        })}
    </TableRow>
  );
};
